export const deviceInventory = [
  {
    device: "SCADA-CTRL-01",
    model: "Siemens SIMATIC S7-1500",
    purdue: "Level 3",
    hashDisplay: "SHA256:a87d9e2e1b...8f2d",
    hashUrl: "#",
    health: 98,
    sl: "SL-3",
  },
  {
    device: "PLC-PROD-12",
    model: "Siemens S7-1200",
    purdue: "Level 1",
    hashDisplay: "SHA256:b9e8c34df2a5...9e3c",
    hashUrl: "#",
    health: 95,
    sl: "SL-2",
  },
  {
    device: "HMI-FLOOR-3",
    model: "Rockwell PanelView Plus 7",
    purdue: "Level 3",
    hashDisplay: "SHA256:c1094ef5a6b7...104e",
    hashUrl: "#",
    health: 92,
    sl: "SL-3",
  },
  {
    device: "RTU-PUMP-08",
    model: "Schneider Electric Modicon M580",
    purdue: "Level 1",
    hashDisplay: "SHA256:d2e1f6g7h8i9...2e1f",
    hashUrl: "#",
    health: 88,
    sl: "SL-2",
  },
  {
    device: "GATEWAY-OT-01",
    model: "Cisco IE-4000",
    purdue: "Level 4",
    hashDisplay: "SHA256:e3f7a8i9j1...3f2g",
    hashUrl: "#",
    health: 100,
    sl: "SL-4",
  },
  {
    device: "PLC-CONV-05",
    model: "ABB AC500",
    purdue: "Level 1",
    hashDisplay: "SHA256:f4g3h8i9j1k2...4g3h",
    hashUrl: "#",
    health: 78,
    sl: "SL-2",
  },
];
export const dashboard = {
  title: "IEC 62443 Compliance & OT Security Dashboard",
  subtitle:
    "Industrial Automation Security Assessment - Last Updated: Dec 18, 2024 09:45 AM",
  score: 81.3,
  target: "95% by Q2 2025",
};

export const securityLevels = [
  {
    id: "sl1",
    title: "SL-1",
    description: "Casual Violation",
    percent: 100,
    status: "Compliant",
    controls: "42/42 controls",
    tone: "toneGreen",
    toneBg: "toneGreenBg",
    icon: "shield",
  },
  {
    id: "sl2",
    title: "SL-2",
    description: "Intentional Violation",
    percent: 95,
    status: "Compliant",
    controls: "55/58 controls",
    tone: "toneTeal",
    toneBg: "toneTealBg",
    icon: "lock",
  },
  {
    id: "sl3",
    title: "SL-3",
    description: "Sophisticated Means",
    percent: 76,
    status: "Partial",
    controls: "58/74 controls",
    tone: "toneAmber",
    toneBg: "toneAmberBg",
    icon: "shield",
  },
  {
    id: "sl4",
    title: "SL-4",
    description: "Advanced Threats",
    percent: 52,
    status: "In Progress",
    controls: "50/96 controls",
    tone: "toneBlue",
    toneBg: "toneBlueBg",
    icon: "fingerprint",
  },
];

export const networkZones = [
  {
    id: "enterprise",
    name: "Enterprise Zone",
    description: "Business Planning & Logistics",
    purdue: "Level 4-5",
    securityLevel: "SL-2",
    devices: 47,
    vlan: "10.9.86.x / 19",
    badge: "Firewall",
    tone: "zoneOrange",
  },
  {
    id: "control",
    name: "Control Zone",
    description: "Manufacturing Operations & Control",
    purdue: "Level 3",
    securityLevel: "SL-3",
    devices: 12,
    vlan: "10.20.9.0/18",
    badge: "Firewall",
    tone: "zoneTeal",
  },
  {
    id: "field",
    name: "Field Zone",
    description: "Process Control & Safety",
    purdue: "Level 0-2",
    securityLevel: "SL-3",
    devices: 142,
    vlan: "10.8.6.6/19",
    badge: "Shield",
    tone: "zoneGold",
  },
];

export const frSections = [
  {
    id: "IAC",
    title: "Identification and Authentication Control",
    total: "35 of 35",
    requirements: [
      {
        label: "FR 1.1 Human user identification and authentication",
        statuses: ["complete", "complete", "complete", "complete"],
      },
      {
        label: "FR 1.2 Software process and device identification",
        statuses: ["complete", "complete", "complete", "partial"],
      },
      {
        label: "FR 1.3 Account management",
        statuses: ["complete", "complete", "complete", "in-progress"],
      },
      {
        label: "FR 1.4 Identifier management",
        statuses: ["complete", "complete", "complete", "complete"],
      },
      {
        label: "FR 1.5 Authenticator management",
        statuses: ["complete", "complete", "complete", "in-progress"],
      },
    ],
  },
  {
    id: "UC",
    title: "Use Control",
    total: "38 of 52",
    requirements: [
      {
        label: "FR 2.1 Authorization enforcement",
        statuses: ["complete", "complete", "complete", "in-progress"],
      },
      {
        label: "FR 2.2 Wireless access management",
        statuses: ["complete", "complete", "partial", "not-started"],
      },
      {
        label: "FR 2.3 Use control for portable devices",
        statuses: ["complete", "complete", "complete", "not-started"],
      },
      {
        label: "FR 2.4 Mobile code",
        statuses: ["complete", "complete", "complete", "in-progress"],
      },
      {
        label: "FR 2.5 Session lock",
        statuses: ["complete", "complete", "complete", "complete"],
      },
    ],
  },
  {
    id: "SI",
    title: "System Integrity",
    total: "15 of 31",
    requirements: [
      {
        label: "FR 3.1 Communication integrity",
        statuses: ["complete", "complete", "complete", "complete"],
      },
      {
        label: "FR 3.2 Malicious code protection",
        statuses: ["complete", "complete", "complete", "partial"],
      },
      {
        label: "FR 3.3 Security functionality verification",
        statuses: ["complete", "complete", "complete", "partial"],
      },
      {
        label: "FR 3.4 Software and information integrity",
        statuses: ["complete", "complete", "complete", "in-progress"],
      },
    ],
  },
  {
    id: "DC",
    title: "Data Confidentiality",
    total: "20 of 32",
    requirements: [
      {
        label: "FR 4.1 Information confidentiality",
        statuses: ["complete", "complete", "complete", "partial"],
      },
      {
        label: "FR 4.2 Information persistence",
        statuses: ["not-started", "not-started", "not-started", "not-started"],
      },
      {
        label: "FR 4.3 Use of cryptography",
        statuses: ["complete", "complete", "complete", "complete"],
      },
    ],
  },
];

export const cveAlerts = [
  {
    id: "CVE-2024-8234",
    severity: "Critical",
    score: 9.8,
    title: "Siemens SIMATIC S7-1500 Authentication Bypass",
    product: "Siemens SIMATIC S7-1500",
    purdue: "Level 3",
    affected: "3 devices",
    status: "unpatched",
  },
  {
    id: "CVE-2024-7891",
    severity: "High",
    score: 8.8,
    title: "Rockwell FactoryTalk Command Injection",
    product: "Rockwell FactoryTalk",
    purdue: "Level 1",
    affected: "1 device",
    status: "patch available",
  },
  {
    id: "CVE-2024-7654",
    severity: "High",
    score: 7.9,
    title: "Schneider Electric Modicon Buffer Overflow",
    product: "Schneider Electric Modicon",
    purdue: "Level 2",
    affected: "2 devices",
    status: "patch available",
  },
  {
    id: "CVE-2024-7223",
    severity: "Medium",
    score: 6.5,
    title: "ABB 800xA Information Disclosure",
    product: "ABB 800xA",
    purdue: "Level 3",
    affected: "1 device",
    status: "mitigated",
  },
];
